import { createSelector } from 'reselect';

export const getUserBounds = state => state.coordinates.userBounds;

export const mapIsDrawn = createSelector(
  [getUserBounds],
  userBounds => userBounds != null && Object.keys(userBounds).length > 0
);